/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAdministratorControlPanelRouteImport } from './routes/_app/administratorControlPanel'
import { Route as AppAssistantsRouteImport } from './routes/_app/assistants'
import { Route as AppChatRouteRouteImport } from './routes/_app/chat/route'
import { Route as AppDocumentTranslationRouteImport } from './routes/_app/documentTranslation'
import { Route as AppPrivacyNoticeRouteImport } from './routes/_app/privacyNotice'
import { Route as AppProjectRouteRouteImport } from './routes/_app/project/route'
import { Route as AppSearchRouteImport } from './routes/_app/search'
import { Route as AppAssistantCreateRouteRouteImport } from './routes/_app/assistant/create/route'
import { Route as AppAssistantUpdateRouteRouteImport } from './routes/_app/assistant/update/route'
import { Route as AppChatIndexRouteImport } from './routes/_app/chat/index'
import { Route as AppChatConversationIdRouteImport } from './routes/_app/chat/$conversationId'
import { Route as AppProjectIndexRouteImport } from './routes/_app/project/index'
import { Route as AppAssistantCreateIndexRouteImport } from './routes/_app/assistant/create/index'
import { Route as AppAssistantCreateConversationIdRouteImport } from './routes/_app/assistant/create/$conversationId'
import { Route as AppAssistantUpdateIndexRouteImport } from './routes/_app/assistant/update/index'
import { Route as AppAssistantUpdateAssistantNameRouteImport } from './routes/_app/assistant/update/$assistantName'
import { Route as AppProjectProjectIdIndexRouteImport } from './routes/_app/project/$projectId/index'
import { Route as AppProjectProjectIdConversationIdRouteImport } from './routes/_app/project/$projectId/$conversationId'
import { Route as AppAssistantKnowledgeAssistantNameKnowledgeIdRouteImport } from './routes/_app/assistant/knowledge/$assistantName.$knowledgeId'

const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAdministratorControlPanelRoute =
  AppAdministratorControlPanelRouteImport.update({
    id: '/administratorControlPanel',
    path: '/administratorControlPanel',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAssistantsRoute = AppAssistantsRouteImport.update({
  id: '/assistants',
  path: '/assistants',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppChatRouteRoute = AppChatRouteRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDocumentTranslationRoute = AppDocumentTranslationRouteImport.update({
  id: '/documentTranslation',
  path: '/documentTranslation',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppPrivacyNoticeRoute = AppPrivacyNoticeRouteImport.update({
  id: '/privacyNotice',
  path: '/privacyNotice',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProjectRouteRoute = AppProjectRouteRouteImport.update({
  id: '/project',
  path: '/project',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSearchRoute = AppSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAssistantCreateRouteRoute = AppAssistantCreateRouteRouteImport.update({
  id: '/assistant/create',
  path: '/assistant/create',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAssistantUpdateRouteRoute = AppAssistantUpdateRouteRouteImport.update({
  id: '/assistant/update',
  path: '/assistant/update',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppChatIndexRoute = AppChatIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppChatRouteRoute,
} as any)
const AppChatConversationIdRoute = AppChatConversationIdRouteImport.update({
  id: '/$conversationId',
  path: '/$conversationId',
  getParentRoute: () => AppChatRouteRoute,
} as any)
const AppProjectIndexRoute = AppProjectIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppProjectRouteRoute,
} as any)
const AppAssistantCreateIndexRoute = AppAssistantCreateIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAssistantCreateRouteRoute,
} as any)
const AppAssistantCreateConversationIdRoute =
  AppAssistantCreateConversationIdRouteImport.update({
    id: '/$conversationId',
    path: '/$conversationId',
    getParentRoute: () => AppAssistantCreateRouteRoute,
  } as any)
const AppAssistantUpdateIndexRoute = AppAssistantUpdateIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAssistantUpdateRouteRoute,
} as any)
const AppAssistantUpdateAssistantNameRoute =
  AppAssistantUpdateAssistantNameRouteImport.update({
    id: '/$assistantName',
    path: '/$assistantName',
    getParentRoute: () => AppAssistantUpdateRouteRoute,
  } as any)
const AppProjectProjectIdIndexRoute =
  AppProjectProjectIdIndexRouteImport.update({
    id: '/$projectId/',
    path: '/$projectId/',
    getParentRoute: () => AppProjectRouteRoute,
  } as any)
const AppProjectProjectIdConversationIdRoute =
  AppProjectProjectIdConversationIdRouteImport.update({
    id: '/$projectId/$conversationId',
    path: '/$projectId/$conversationId',
    getParentRoute: () => AppProjectRouteRoute,
  } as any)
const AppAssistantKnowledgeAssistantNameKnowledgeIdRoute =
  AppAssistantKnowledgeAssistantNameKnowledgeIdRouteImport.update({
    id: '/assistant/knowledge/$assistantName/$knowledgeId',
    path: '/assistant/knowledge/$assistantName/$knowledgeId',
    getParentRoute: () => AppRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/auth': typeof AuthRoute
  '/chat': typeof AppChatRouteRouteWithChildren
  '/project': typeof AppProjectRouteRouteWithChildren
  '/administratorControlPanel': typeof AppAdministratorControlPanelRoute
  '/assistants': typeof AppAssistantsRoute
  '/documentTranslation': typeof AppDocumentTranslationRoute
  '/privacyNotice': typeof AppPrivacyNoticeRoute
  '/search': typeof AppSearchRoute
  '/assistant/create': typeof AppAssistantCreateRouteRouteWithChildren
  '/assistant/update': typeof AppAssistantUpdateRouteRouteWithChildren
  '/chat/$conversationId': typeof AppChatConversationIdRoute
  '/chat/': typeof AppChatIndexRoute
  '/project/': typeof AppProjectIndexRoute
  '/assistant/create/$conversationId': typeof AppAssistantCreateConversationIdRoute
  '/assistant/update/$assistantName': typeof AppAssistantUpdateAssistantNameRoute
  '/project/$projectId/$conversationId': typeof AppProjectProjectIdConversationIdRoute
  '/assistant/create/': typeof AppAssistantCreateIndexRoute
  '/assistant/update/': typeof AppAssistantUpdateIndexRoute
  '/project/$projectId/': typeof AppProjectProjectIdIndexRoute
  '/assistant/knowledge/$assistantName/$knowledgeId': typeof AppAssistantKnowledgeAssistantNameKnowledgeIdRoute
}
export interface FileRoutesByTo {
  '/auth': typeof AuthRoute
  '/administratorControlPanel': typeof AppAdministratorControlPanelRoute
  '/assistants': typeof AppAssistantsRoute
  '/documentTranslation': typeof AppDocumentTranslationRoute
  '/privacyNotice': typeof AppPrivacyNoticeRoute
  '/search': typeof AppSearchRoute
  '/': typeof AppIndexRoute
  '/chat/$conversationId': typeof AppChatConversationIdRoute
  '/chat': typeof AppChatIndexRoute
  '/project': typeof AppProjectIndexRoute
  '/assistant/create/$conversationId': typeof AppAssistantCreateConversationIdRoute
  '/assistant/update/$assistantName': typeof AppAssistantUpdateAssistantNameRoute
  '/project/$projectId/$conversationId': typeof AppProjectProjectIdConversationIdRoute
  '/assistant/create': typeof AppAssistantCreateIndexRoute
  '/assistant/update': typeof AppAssistantUpdateIndexRoute
  '/project/$projectId': typeof AppProjectProjectIdIndexRoute
  '/assistant/knowledge/$assistantName/$knowledgeId': typeof AppAssistantKnowledgeAssistantNameKnowledgeIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/auth': typeof AuthRoute
  '/_app/chat': typeof AppChatRouteRouteWithChildren
  '/_app/project': typeof AppProjectRouteRouteWithChildren
  '/_app/administratorControlPanel': typeof AppAdministratorControlPanelRoute
  '/_app/assistants': typeof AppAssistantsRoute
  '/_app/documentTranslation': typeof AppDocumentTranslationRoute
  '/_app/privacyNotice': typeof AppPrivacyNoticeRoute
  '/_app/search': typeof AppSearchRoute
  '/_app/': typeof AppIndexRoute
  '/_app/assistant/create': typeof AppAssistantCreateRouteRouteWithChildren
  '/_app/assistant/update': typeof AppAssistantUpdateRouteRouteWithChildren
  '/_app/chat/$conversationId': typeof AppChatConversationIdRoute
  '/_app/chat/': typeof AppChatIndexRoute
  '/_app/project/': typeof AppProjectIndexRoute
  '/_app/assistant/create/$conversationId': typeof AppAssistantCreateConversationIdRoute
  '/_app/assistant/update/$assistantName': typeof AppAssistantUpdateAssistantNameRoute
  '/_app/project/$projectId/$conversationId': typeof AppProjectProjectIdConversationIdRoute
  '/_app/assistant/create/': typeof AppAssistantCreateIndexRoute
  '/_app/assistant/update/': typeof AppAssistantUpdateIndexRoute
  '/_app/project/$projectId/': typeof AppProjectProjectIdIndexRoute
  '/_app/assistant/knowledge/$assistantName/$knowledgeId': typeof AppAssistantKnowledgeAssistantNameKnowledgeIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/chat'
    | '/project'
    | '/administratorControlPanel'
    | '/assistants'
    | '/documentTranslation'
    | '/privacyNotice'
    | '/search'
    | '/assistant/create'
    | '/assistant/update'
    | '/chat/$conversationId'
    | '/chat/'
    | '/project/'
    | '/assistant/create/$conversationId'
    | '/assistant/update/$assistantName'
    | '/project/$projectId/$conversationId'
    | '/assistant/create/'
    | '/assistant/update/'
    | '/project/$projectId/'
    | '/assistant/knowledge/$assistantName/$knowledgeId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth'
    | '/administratorControlPanel'
    | '/assistants'
    | '/documentTranslation'
    | '/privacyNotice'
    | '/search'
    | '/'
    | '/chat/$conversationId'
    | '/chat'
    | '/project'
    | '/assistant/create/$conversationId'
    | '/assistant/update/$assistantName'
    | '/project/$projectId/$conversationId'
    | '/assistant/create'
    | '/assistant/update'
    | '/project/$projectId'
    | '/assistant/knowledge/$assistantName/$knowledgeId'
  id:
    | '__root__'
    | '/_app'
    | '/auth'
    | '/_app/chat'
    | '/_app/project'
    | '/_app/administratorControlPanel'
    | '/_app/assistants'
    | '/_app/documentTranslation'
    | '/_app/privacyNotice'
    | '/_app/search'
    | '/_app/'
    | '/_app/assistant/create'
    | '/_app/assistant/update'
    | '/_app/chat/$conversationId'
    | '/_app/chat/'
    | '/_app/project/'
    | '/_app/assistant/create/$conversationId'
    | '/_app/assistant/update/$assistantName'
    | '/_app/project/$projectId/$conversationId'
    | '/_app/assistant/create/'
    | '/_app/assistant/update/'
    | '/_app/project/$projectId/'
    | '/_app/assistant/knowledge/$assistantName/$knowledgeId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AuthRoute: typeof AuthRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/administratorControlPanel': {
      id: '/_app/administratorControlPanel'
      path: '/administratorControlPanel'
      fullPath: '/administratorControlPanel'
      preLoaderRoute: typeof AppAdministratorControlPanelRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/assistants': {
      id: '/_app/assistants'
      path: '/assistants'
      fullPath: '/assistants'
      preLoaderRoute: typeof AppAssistantsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/chat': {
      id: '/_app/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof AppChatRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/documentTranslation': {
      id: '/_app/documentTranslation'
      path: '/documentTranslation'
      fullPath: '/documentTranslation'
      preLoaderRoute: typeof AppDocumentTranslationRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/privacyNotice': {
      id: '/_app/privacyNotice'
      path: '/privacyNotice'
      fullPath: '/privacyNotice'
      preLoaderRoute: typeof AppPrivacyNoticeRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/project': {
      id: '/_app/project'
      path: '/project'
      fullPath: '/project'
      preLoaderRoute: typeof AppProjectRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/search': {
      id: '/_app/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AppSearchRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/assistant/create': {
      id: '/_app/assistant/create'
      path: '/assistant/create'
      fullPath: '/assistant/create'
      preLoaderRoute: typeof AppAssistantCreateRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/assistant/update': {
      id: '/_app/assistant/update'
      path: '/assistant/update'
      fullPath: '/assistant/update'
      preLoaderRoute: typeof AppAssistantUpdateRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/chat/': {
      id: '/_app/chat/'
      path: '/'
      fullPath: '/chat/'
      preLoaderRoute: typeof AppChatIndexRouteImport
      parentRoute: typeof AppChatRouteRoute
    }
    '/_app/chat/$conversationId': {
      id: '/_app/chat/$conversationId'
      path: '/$conversationId'
      fullPath: '/chat/$conversationId'
      preLoaderRoute: typeof AppChatConversationIdRouteImport
      parentRoute: typeof AppChatRouteRoute
    }
    '/_app/project/': {
      id: '/_app/project/'
      path: '/'
      fullPath: '/project/'
      preLoaderRoute: typeof AppProjectIndexRouteImport
      parentRoute: typeof AppProjectRouteRoute
    }
    '/_app/assistant/create/': {
      id: '/_app/assistant/create/'
      path: '/'
      fullPath: '/assistant/create/'
      preLoaderRoute: typeof AppAssistantCreateIndexRouteImport
      parentRoute: typeof AppAssistantCreateRouteRoute
    }
    '/_app/assistant/create/$conversationId': {
      id: '/_app/assistant/create/$conversationId'
      path: '/$conversationId'
      fullPath: '/assistant/create/$conversationId'
      preLoaderRoute: typeof AppAssistantCreateConversationIdRouteImport
      parentRoute: typeof AppAssistantCreateRouteRoute
    }
    '/_app/assistant/update/': {
      id: '/_app/assistant/update/'
      path: '/'
      fullPath: '/assistant/update/'
      preLoaderRoute: typeof AppAssistantUpdateIndexRouteImport
      parentRoute: typeof AppAssistantUpdateRouteRoute
    }
    '/_app/assistant/update/$assistantName': {
      id: '/_app/assistant/update/$assistantName'
      path: '/$assistantName'
      fullPath: '/assistant/update/$assistantName'
      preLoaderRoute: typeof AppAssistantUpdateAssistantNameRouteImport
      parentRoute: typeof AppAssistantUpdateRouteRoute
    }
    '/_app/project/$projectId/': {
      id: '/_app/project/$projectId/'
      path: '/$projectId'
      fullPath: '/project/$projectId/'
      preLoaderRoute: typeof AppProjectProjectIdIndexRouteImport
      parentRoute: typeof AppProjectRouteRoute
    }
    '/_app/project/$projectId/$conversationId': {
      id: '/_app/project/$projectId/$conversationId'
      path: '/$projectId/$conversationId'
      fullPath: '/project/$projectId/$conversationId'
      preLoaderRoute: typeof AppProjectProjectIdConversationIdRouteImport
      parentRoute: typeof AppProjectRouteRoute
    }
    '/_app/assistant/knowledge/$assistantName/$knowledgeId': {
      id: '/_app/assistant/knowledge/$assistantName/$knowledgeId'
      path: '/assistant/knowledge/$assistantName/$knowledgeId'
      fullPath: '/assistant/knowledge/$assistantName/$knowledgeId'
      preLoaderRoute: typeof AppAssistantKnowledgeAssistantNameKnowledgeIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppChatRouteRouteChildren {
  AppChatConversationIdRoute: typeof AppChatConversationIdRoute
  AppChatIndexRoute: typeof AppChatIndexRoute
}

const AppChatRouteRouteChildren: AppChatRouteRouteChildren = {
  AppChatConversationIdRoute: AppChatConversationIdRoute,
  AppChatIndexRoute: AppChatIndexRoute,
}

const AppChatRouteRouteWithChildren = AppChatRouteRoute._addFileChildren(
  AppChatRouteRouteChildren,
)

interface AppProjectRouteRouteChildren {
  AppProjectIndexRoute: typeof AppProjectIndexRoute
  AppProjectProjectIdConversationIdRoute: typeof AppProjectProjectIdConversationIdRoute
  AppProjectProjectIdIndexRoute: typeof AppProjectProjectIdIndexRoute
}

const AppProjectRouteRouteChildren: AppProjectRouteRouteChildren = {
  AppProjectIndexRoute: AppProjectIndexRoute,
  AppProjectProjectIdConversationIdRoute:
    AppProjectProjectIdConversationIdRoute,
  AppProjectProjectIdIndexRoute: AppProjectProjectIdIndexRoute,
}

const AppProjectRouteRouteWithChildren = AppProjectRouteRoute._addFileChildren(
  AppProjectRouteRouteChildren,
)

interface AppAssistantCreateRouteRouteChildren {
  AppAssistantCreateConversationIdRoute: typeof AppAssistantCreateConversationIdRoute
  AppAssistantCreateIndexRoute: typeof AppAssistantCreateIndexRoute
}

const AppAssistantCreateRouteRouteChildren: AppAssistantCreateRouteRouteChildren =
  {
    AppAssistantCreateConversationIdRoute:
      AppAssistantCreateConversationIdRoute,
    AppAssistantCreateIndexRoute: AppAssistantCreateIndexRoute,
  }

const AppAssistantCreateRouteRouteWithChildren =
  AppAssistantCreateRouteRoute._addFileChildren(
    AppAssistantCreateRouteRouteChildren,
  )

interface AppAssistantUpdateRouteRouteChildren {
  AppAssistantUpdateAssistantNameRoute: typeof AppAssistantUpdateAssistantNameRoute
  AppAssistantUpdateIndexRoute: typeof AppAssistantUpdateIndexRoute
}

const AppAssistantUpdateRouteRouteChildren: AppAssistantUpdateRouteRouteChildren =
  {
    AppAssistantUpdateAssistantNameRoute: AppAssistantUpdateAssistantNameRoute,
    AppAssistantUpdateIndexRoute: AppAssistantUpdateIndexRoute,
  }

const AppAssistantUpdateRouteRouteWithChildren =
  AppAssistantUpdateRouteRoute._addFileChildren(
    AppAssistantUpdateRouteRouteChildren,
  )

interface AppRouteRouteChildren {
  AppChatRouteRoute: typeof AppChatRouteRouteWithChildren
  AppProjectRouteRoute: typeof AppProjectRouteRouteWithChildren
  AppAdministratorControlPanelRoute: typeof AppAdministratorControlPanelRoute
  AppAssistantsRoute: typeof AppAssistantsRoute
  AppDocumentTranslationRoute: typeof AppDocumentTranslationRoute
  AppPrivacyNoticeRoute: typeof AppPrivacyNoticeRoute
  AppSearchRoute: typeof AppSearchRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAssistantCreateRouteRoute: typeof AppAssistantCreateRouteRouteWithChildren
  AppAssistantUpdateRouteRoute: typeof AppAssistantUpdateRouteRouteWithChildren
  AppAssistantKnowledgeAssistantNameKnowledgeIdRoute: typeof AppAssistantKnowledgeAssistantNameKnowledgeIdRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppChatRouteRoute: AppChatRouteRouteWithChildren,
  AppProjectRouteRoute: AppProjectRouteRouteWithChildren,
  AppAdministratorControlPanelRoute: AppAdministratorControlPanelRoute,
  AppAssistantsRoute: AppAssistantsRoute,
  AppDocumentTranslationRoute: AppDocumentTranslationRoute,
  AppPrivacyNoticeRoute: AppPrivacyNoticeRoute,
  AppSearchRoute: AppSearchRoute,
  AppIndexRoute: AppIndexRoute,
  AppAssistantCreateRouteRoute: AppAssistantCreateRouteRouteWithChildren,
  AppAssistantUpdateRouteRoute: AppAssistantUpdateRouteRouteWithChildren,
  AppAssistantKnowledgeAssistantNameKnowledgeIdRoute:
    AppAssistantKnowledgeAssistantNameKnowledgeIdRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  AuthRoute: AuthRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
